module.exports = __webpack_public_path__ + "img/plan_auto.f0a5e681.svg";